import React from 'react';
import { forEach, keys } from 'lodash';
import { BrowserRouter as Router, Switch, Route, Link, Redirect } from 'react-router-dom';
import { Login } from './Login';
import { Lobby } from './Lobby';
import { Room } from './Room';
import { CurrentUserContext } from '../contexts/CurrentUserContext';
import { database } from '../firestore';
import { createGlobalStyle } from 'styled-components';
import styled from 'styled-components';

const GlobalStyle = createGlobalStyle`
    html, body, #root {
        height: 100%;
        width: 100%;
        position: relative;
        overflow: hidden;
        font-family: 'Handlee', cursive;
    }

    #root {
        display: flex;
        flex-direction: column;
    }

    * {
        box-sizing: border-box;
    }
`;

const Links = styled.div`
    display: flex;
    justify-content: flex-end;
`;

const StyledLink = styled(Link)`
    display: block;
`;

const RouteContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;
export function App({ existingUserId }: any) {
    const [currentUserId, setCurrentUserId] = React.useState(existingUserId);

    const currentUserContextValue = React.useMemo(
        () => ({
            currentUserId,
            setCurrentUserId,
        }),
        [currentUserId, setCurrentUserId],
    );

    /*
    React.useEffect(() => {
        if (currentUserId) {
            // Remove the user
            const cb = (dataSnapshot: firebase.database.DataSnapshot) => {
                forEach(keys(dataSnapshot.val()), (key) =>
                    dataSnapshot.ref.child(key).onDisconnect().remove(),
                );
            };
            // Remove the user from room
            const ref = database.ref('userRoomLinks').orderByChild('userId').equalTo(currentUserId);
            ref.on('value', cb);
            return () => ref.off('value', cb);
        }
    }, [currentUserId]);
    */

    return (
        <Router>
            <GlobalStyle />
            <CurrentUserContext.Provider value={currentUserContextValue}>
                <Links>
                    <StyledLink to="/">Home</StyledLink>
                    <StyledLink to="/lobby">Lobby</StyledLink>
                    <StyledLink to="/users">Users</StyledLink>
                </Links>
                <RouteContainer>
                    <Switch>
                        <Route path="/lobby">
                            {currentUserId ? <Lobby /> : <Redirect to="/" />}
                        </Route>
                        <Route path="/room/:roomId">
                            {currentUserId ? <Room /> : <Redirect to="/" />}
                        </Route>
                        <Route path="/">
                            <Login />
                        </Route>
                    </Switch>
                </RouteContainer>
            </CurrentUserContext.Provider>
        </Router>
    );
}
